export default __webpack_public_path__ + "static/media/arivatwo5.856ab42e.jpg";